export function buildFuelTypeOptions(fuelTypes) {
    return (Array.isArray(fuelTypes) ? fuelTypes : [])
        .slice()
        .sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), 'ru'))
        .map(type => ({
            value: Number(type.id),
            text: type.unit ? `${type.name} (${type.unit})` : type.name
        }));
}

export function buildFuelTypeById(options) {
    const result = {};
    (Array.isArray(options) ? options : []).forEach(option => {
        result[Number(option.value)] = option.text;
    });
    return result;
}

export function normalizeFuelLimitType(value) {
    const fuelTypeId = Number(value);
    return Number.isInteger(fuelTypeId) && fuelTypeId > 0 ? fuelTypeId : null;
}

export function normalizeFuelLimitValue(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    if (typeof value === 'string' && value.trim() === '') {
        return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
}

function setLimitField(limit, field, value, setter) {
    if (!limit) {
        return;
    }
    if (typeof setter === 'function') {
        setter(limit, field, value);
    } else {
        limit[field] = value;
    }
}

export function setFuelLimitType(limit, value, setter) {
    setLimitField(limit, 'fuel_type_id', normalizeFuelLimitType(value), setter);
}

export function setFuelLimitValue(limit, value, setter) {
    setLimitField(limit, 'value', normalizeFuelLimitValue(value), setter);
}

export function syncFuelLimitControls({ root, typeSelector, valueSelector, getLimit, setter }) {
    if (!root || typeof getLimit !== 'function') {
        return;
    }

    if (typeSelector) {
        root.querySelectorAll(typeSelector).forEach(control => {
            setFuelLimitType(getLimit(control), control.value, setter);
        });
    }

    if (valueSelector) {
        root.querySelectorAll(valueSelector).forEach(control => {
            setFuelLimitValue(getLimit(control), control.value, setter);
        });
    }
}

export function sanitizeFuelLimits(value) {
    if (!Array.isArray(value)) {
        return [];
    }

    const byFuelTypeId = {};
    value.forEach(limit => {
        const fuelTypeId = Number(limit && limit.fuel_type_id);
        const limitValue = normalizeFuelLimitValue(limit && limit.value);
        if (!Number.isInteger(fuelTypeId) || fuelTypeId <= 0 || !Number.isFinite(limitValue) || limitValue < 0) {
            return;
        }
        byFuelTypeId[fuelTypeId] = {
            fuel_type_id: fuelTypeId,
            value: limitValue
        };
    });

    return Object.keys(byFuelTypeId)
        .map(id => byFuelTypeId[id])
        .sort((a, b) => a.fuel_type_id - b.fuel_type_id);
}

export function cloneFuelLimits(value) {
    return sanitizeFuelLimits(value).map(limit => Object.assign({}, limit));
}

export function formatFuelLimits(value, fuelTypeById, formatValue) {
    const limits = sanitizeFuelLimits(value);
    if (!limits.length) {
        return '';
    }

    const names = fuelTypeById || {};
    const valueFormatter = typeof formatValue === 'function' ? formatValue : item => item;
    return limits.map(limit => {
        const name = names[limit.fuel_type_id] || `Топливо ${limit.fuel_type_id}`;
        return `${name}: ${valueFormatter(limit.value)}`;
    }).join('; ');
}
